var _path, _path2, _path3, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_624",
    "data-name": "Group 624",
    xmlns: "http://www.w3.org/2000/svg",
    width: 143.577,
    height: 40.352,
    viewBox: "0 0 143.577 40.352",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M280.455,167.483h-5.367c-.014,0-.028,0-.042,0h0a2.113,2.113,0,0,0-2.107,2.107v5.323a2.113,2.113,0,0,0,2.107,2.107h.085A2.027,2.027,0,0,0,277.153,175v-3.3h3.216a2.113,2.113,0,0,0,2.107-2.107V169.5A2.027,2.027,0,0,0,280.455,167.483Z",
    transform: "translate(-138.899 -162.165)",
    fill: "#54c1bd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M271.768,158.892h-.086a2.027,2.027,0,0,0-2.021,2.021v3.3h-3.216a2.113,2.113,0,0,0-2.107,2.107v.086a2.027,2.027,0,0,0,2.021,2.021h5.366c.015,0,.028,0,.043,0a2.113,2.113,0,0,0,2.107-2.107V161A2.113,2.113,0,0,0,271.768,158.892Z",
    transform: "translate(-135.62 -158.892)",
    fill: "#2d617b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M275.046,167.479a2.113,2.113,0,0,0-2.107,2.107V171.7H275c.015,0,.028,0,.043,0a2.113,2.113,0,0,0,2.107-2.107v-2.112h-2.065C275.074,167.483,275.06,167.479,275.046,167.479Z",
    transform: "translate(-138.899 -162.165)",
    fill: "#04496b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_621",
    "data-name": "Group 621",
    transform: "translate(0 5.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M149.608,196.566a12.2,12.2,0,0,0-12.021-12.353,12.061,12.061,0,0,0-12.022,12.353,11.792,11.792,0,0,0,7.635,11.4,13.618,13.618,0,0,0,14.822-3.362l-1.52-1.377a11.89,11.89,0,0,1-12.123,3.036,9.572,9.572,0,0,1-6.686-8.315l-.043-.371h21.958Zm-21.954-1.039.039-.369a9.935,9.935,0,0,1,19.764,0l.045.374Z",
    transform: "translate(-82.729 -173.577)",
    fill: "#2d617b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M117.224,177.228H105.9v-4.484a3.037,3.037,0,0,1,3.116-3.326h5.017v-1.978h-5.017c-.051,0-5.093.061-5.093,5.3v4.484h-3.747v1.977h3.747v22.9H105.9v-22.9h11.324Z",
    transform: "translate(-73.053 -167.184)",
    fill: "#2d617b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M84.361,185.233h4.413v22.9h1.978V183.256H84.361Z",
    transform: "translate(-67.025 -173.212)",
    fill: "#2d617b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M58.326,194.378v-26.87H56.349v26.87c0,7.5,6.4,7.584,6.461,7.584H73.193v-1.978H62.816C62.356,199.979,58.326,199.776,58.326,194.378Z",
    transform: "translate(-56.349 -167.21)",
    fill: "#2d617b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M92.139,167.026a1.544,1.544,0,1,0,1.543,1.543A1.544,1.544,0,0,0,92.139,167.026Z",
    transform: "translate(-69.402 -167.026)",
    fill: "#2d617b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M149.608,196.566a12.2,12.2,0,0,0-12.021-12.353,12.061,12.061,0,0,0-12.022,12.353,11.792,11.792,0,0,0,7.635,11.4,13.618,13.618,0,0,0,14.822-3.362l-1.52-1.377a11.89,11.89,0,0,1-12.123,3.036,9.572,9.572,0,0,1-6.686-8.315l-.043-.371h21.958Zm-21.954-1.039.039-.369a9.935,9.935,0,0,1,19.764,0l.045.374Z",
    transform: "translate(-82.729 -173.577)",
    fill: "#2d617b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_620",
    "data-name": "Group 620"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M117.224,177.228H105.9v-4.484a3.037,3.037,0,0,1,3.116-3.326h5.017v-1.978h-5.017c-.051,0-5.093.061-5.093,5.3v4.484h-3.747v1.977h3.747v22.9H105.9v-22.9h11.324Z",
    transform: "translate(-73.053 -167.184)",
    fill: "#2d617b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M84.361,185.233h4.413v22.9h1.978V183.256H84.361Z",
    transform: "translate(-67.025 -173.212)",
    fill: "#2d617b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M58.326,194.378V168.5a.988.988,0,0,0-.988-.989h0a.989.989,0,0,0-.989.989v25.882c0,7.5,6.4,7.584,6.461,7.584H72.2a.989.989,0,0,0,.989-.989h0a.989.989,0,0,0-.989-.989H62.816C62.356,199.979,58.326,199.776,58.326,194.378Z",
    transform: "translate(-56.349 -167.21)",
    fill: "#2d617b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M92.139,167.026a1.544,1.544,0,1,0,1.543,1.543A1.544,1.544,0,0,0,92.139,167.026Z",
    transform: "translate(-69.402 -167.026)",
    fill: "#2d617b"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_623",
    "data-name": "Group 623",
    transform: "translate(73.823 9.512)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_622",
    "data-name": "Group 622",
    transform: "translate(35.195 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M256.649,183.605a15.532,15.532,0,0,0-3.289-4.847,15.693,15.693,0,0,0-4.847-3.288,14.469,14.469,0,0,0-5.874-1.207h-9.172a.961.961,0,0,0-.961.961v28.521a.961.961,0,0,0,.961.961h9.172a14.6,14.6,0,0,0,5.892-1.207,15.231,15.231,0,0,0,4.847-3.289,15.614,15.614,0,0,0,3.27-4.847,14.916,14.916,0,0,0,0-11.758Zm-4.665,9.781a10.417,10.417,0,0,1-2.167,3.251,10,10,0,0,1-7.176,2.984h-4.124a.961.961,0,0,1-.961-.96V180.309a.961.961,0,0,1,.961-.961h4.124a9.863,9.863,0,0,1,3.907.79,10.218,10.218,0,0,1,3.24,2.2,10.031,10.031,0,0,1,2.2,3.25,10.048,10.048,0,0,1,0,7.8Z",
    transform: "translate(-232.507 -174.263)",
    fill: "#54c1bd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M204.478,174.545l-12.945,12.913a.917.917,0,0,1-1.311,0l-12.945-12.913a.961.961,0,0,0-1.639.681v28.519a.961.961,0,0,0,.961.961h3.21a.961.961,0,0,0,.961-.961V187.478a.962.962,0,0,1,1.378-.866l8.026,8.028a1.036,1.036,0,0,0,1.409,0l8.026-8.028a.962.962,0,0,1,1.378.866v16.267a.961.961,0,0,0,.961.961h3.21a.961.961,0,0,0,.961-.961V175.226A.961.961,0,0,0,204.478,174.545Z",
    transform: "translate(-175.636 -174.263)",
    fill: "#54c1bd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.58a5432a.svg";
export { ForwardRef as ReactComponent };